import { Loader2Icon } from "lucide-react";
import { cn } from "@/lib/utils";

/** Centered spinner for a page or panel that's still loading its data. */
export function LoadingState({
  label = "Loading…",
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <div
      role="status"
      className={cn(
        "flex flex-1 flex-col items-center justify-center gap-2 p-8 text-muted-foreground",
        className,
      )}
    >
      <Loader2Icon className="size-6 animate-spin" aria-hidden="true" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

/** Full-viewport variant, used while the app is resolving the auth session. */
export function FullScreenLoadingState({ label }: { label?: string }) {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <LoadingState label={label} />
    </div>
  );
}
